// src/App.jsx
import "./App.css";
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Páginas
import Home from "./pages/Home";
import Principios from "./pages/principios";
import Estructura from "./pages/estructura";
import RedInstitucional from "./pages/RedInstituto";
import UsuarioCooperativo from "./pages/usuariocoop";
import Operaciones from "./pages/operaciones";
import Capacitaciones from "./pages/capacitaciones";
import DGRV from "./pages/dgrv";
import Cumplimientos from "./pages/cumplimientos";
import Riesgos from "./pages/riesgos";
import Financieros from "./pages/financieros";
import Memoria from "./pages/memoria";
import Boletines from "./pages/boletines";
import Contacto from "./pages/contacto";
import Asistencia from "./pages/asistencia";
import Biblioteca from "./pages/biblioteca";

import ContactoAt from "./pages/contacto_at";
import ContactoCapa from "./pages/contacto_capacitacion";
import ContactoCumplimiento from "./pages/contacto_cumplimiento";
import ContactoDGRV from "./pages/contacto_dgrv";
import ContactoOP from "./pages/contacto_operaciones";
import ContactoR from "./pages/contacto_riesgos";

import Noticias from "./pages/noticias";
import NoticiaGenerica from "./pages/NoticiaGenerica";

import ComitesMain from "./pages/comitesMain";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ComiteJuventud from "./pages/comiteJuventud";
import ComiteEducacion from "./pages/comiteEducacion";
import ComiteGenero from "./pages/comiteGenero";
import NoticiasComite from "./pages/NoticiasComite";
import SistemaFederado from './pages/SistemaFederado';
import CursosGratuitos from './pages/CursosGratuitos';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/principios" element={<Principios />} />
          <Route path="/estructura" element={<Estructura />} />
          <Route path="/redinstituto" element={<RedInstitucional />} />
          <Route path="/usuariocoop" element={<UsuarioCooperativo />} />
          <Route path="/operaciones" element={<Operaciones />} />
          <Route path="/capacitaciones" element={<Capacitaciones />} />
          <Route path="/dgrv" element={<DGRV />} />
          <Route path="/cumplimientos" element={<Cumplimientos />} />
          <Route path="/riesgos" element={<Riesgos />} />
          <Route path="/financieros" element={<Financieros />} />
          <Route path="/memoria" element={<Memoria />} />
          <Route path="/boletines" element={<Boletines />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/asistencia" element={<Asistencia />} />
          <Route path="/biblioteca" element={<Biblioteca />} />

          <Route path="/contacto_at" element={<ContactoAt />} />
          <Route path="/contacto_capacitacion" element={<ContactoCapa />} />
          <Route path="/contacto_cumplimiento" element={<ContactoCumplimiento />} />
          <Route path="/contacto_dgrv" element={<ContactoDGRV />} />
          <Route path="/contacto_operaciones" element={<ContactoOP />} />
          <Route path="/contacto_riesgos" element={<ContactoR />} />
          <Route path="/comitesMain" element={<ComitesMain/>}/>

          {/* Noticias */}
          <Route path="/noticias" element={<Noticias />} />
          <Route path="/noticias/:id" element={<NoticiaGenerica />} />


          {/* Comites*/ }
          <Route path="/comiteJuventud" element={<ComiteJuventud/>}/>
          <Route path="/comiteEducacion" element={<ComiteEducacion/>}/>
          <Route path="/comiteGenero" element={<ComiteGenero/>}/>
          <Route path="/noticiasComite" element={<NoticiasComite/>}/>

          <Route path="/sistema-federado" element={<SistemaFederado />} />

          <Route path="/cursos-gratuitos" element={<CursosGratuitos />} />
        </Routes>
      </div>
    </Router>
  );
}


export default App;
